import React from "react";
import "./page.css";
import Navbar from "../components/Navbar/Navbar";
import Gallery from "../components/gallery/Gallery";
import Footer from "../components/Footer/Footer";
import ManufacturingTopSection from "../components/manufacturing/ManufacturingTopSection";
import CollegeTopHeroBg from "../assets/images/college-top-hero-bg.png";
import Services from "../components/Services/Services";
import {
  GiGears,
  GiRobotGolem,
  GiFactory,
  GiWifiRouter,
  GiProcessor,
  GiArtificialIntelligence,
} from "react-icons/gi";
import LabCard from "../components/LabCard/LabCard";

const iconMap = {
  GiGears,
  GiRobotGolem,
  GiFactory,
  GiWifiRouter,
  GiProcessor,
  GiArtificialIntelligence,
};

const LabForCollege = () => {
  const images = [
    require("../assets/images/gallery/gallery-1.png"),
    require("../assets/images/gallery/gallery-2.png"),
    require("../assets/images/gallery/gallery-3.png"),
    require("../assets/images/gallery/gallery-4.png"),
    require("../assets/images/gallery/gallery-5.png"),
    require("../assets/images/gallery/gallery-6.png"),
  ];

  const cardData = [
    {
      imageUrl: require("../assets/images/college-lab/college-lab-1.png"),
      icon: "ri-brush-4-line",
      title: "TFT ED-RIG",
      description: "Interactive TFT educational training system",
      linkUrl: "#",
    },
    {
      imageUrl: require("../assets/images/college-lab/college-lab-2.png"),
      icon: "ri-calendar-check-line",
      title: "Automation Station",
      description: "Efficient automated production learning setup",
      linkUrl: "#",
    },
    {
      imageUrl: require("../assets/images/college-lab/college-lab-3.png"),
      icon: "ri-movie-2-line",
      title: "IOT Station",
      description: "Connected devices with real-time analytics",
      linkUrl: "#",
    },
    {
      imageUrl: require("../assets/images/college-lab/college-lab-4.png"),
      icon: "ri-movie-2-line",
      title: "Robotic Arm",
      description: "Precise automated robotic handling solutions",
      linkUrl: "#",
    },
    {
      imageUrl: require("../assets/images/college-lab/college-lab-5.png"),
      icon: "ri-movie-2-line",
      title: "Digital Twin",
      description: "Virtual simulations mirroring real-world systems",
      linkUrl: "#",
    },
    {
      imageUrl: require("../assets/images/college-lab/college-lab-6.png"),
      icon: "ri-movie-2-line",
      title: "Additive Manufacturing",
      description: "Advanced 3D printing production technologies",
      linkUrl: "#",
    },
    {
      imageUrl: require("../assets/images/college-lab/college-lab-7.png"),
      icon: "ri-movie-2-line",
      title: "AR/VR",
      description: "Immersive virtual and augmented reality",
      linkUrl: "#",
    },
    {
      imageUrl: require("../assets/images/college-lab/college-lab-8.png"),
      icon: "ri-movie-2-line",
      title: "Mini-Factory",
      description: "Compact, automated industrial learning setup",
      linkUrl: "#",
    },
  ];

  const servicesData = {
    title: "Technologies Covered",
    section_paragraph:
      "Advanced technologies empowering automation, robotics, and smart systems for innovative, efficient solutions.",
    reasons: [
      {
        heading: "Automation",
        description: "Enhancing efficiency through streamlined processes.",
        icon: "GiGears",
        icon_size: 30,
      },
      {
        heading: "Robotics",
        description: "Designing intelligent machines for various tasks.",
        icon: "GiRobotGolem",
        icon_size: 30,
      },
      {
        heading: "Industry 4.0",
        description:
          "Revolutionizing manufacturing with advanced technologies.",
        icon: "GiFactory",
        icon_size: 30,
      },
      {
        heading: "IoT Connectivity",
        description:
          "Connecting devices for data-driven insights and automation.",
        icon: "GiWifiRouter",
        icon_size: 30,
      },
      {
        heading: "Embedded Systems",
        description: "Tailoring computing systems for specific functions.",
        icon: "GiProcessor",
        icon_size: 30,
      },
      {
        heading: "Artificial Intelligence",
        description:
          "Empowering machines to learn and make autonomous decisions.",
        icon: "GiArtificialIntelligence",
        icon_size: 30,
      },
    ],
  };

  return (
    <div className="learning-page" style={{ backgroundColor: "white" }}>
      <Navbar />
      <div style={{ backgroundColor: "#00061C" }}>
        <ManufacturingTopSection
          title="Industry 4.0 Labs For Institutes"
          description="Providing institutes advanced Industry 4.0 labs, empowering students through hands-on training in robotics and automation."
          backgroundImage={CollegeTopHeroBg}
          buttonText="Watch Video"
          videoUrl="https://www.youtube.com/watch?v=APeTAEt_ASo"
        />
      </div>

      <LabCard cardData={cardData} />
      <section className="gallery-section">
        <h1 className="automation-heading">
          Automation & Industry 4.0 lab gallery
        </h1>
        <Gallery images={images} />
      </section>
      <Services data={servicesData} iconMap={iconMap} />
      <Footer />
    </div>
  );
};

export default LabForCollege;
